import React, { memo } from 'react'
import { Trans } from 'react-i18next'
import { Link } from '@mui/material'

import brandConfig from 'brandConfig'
import customConfig from 'customConfig'
import Text from '../text/Text'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'

const CustomerHelpDesk = ({ t, customFaq }) => {
  const { faqEmail, faqUrl } = brandConfig
  const to = faqEmail ? faqEmail : customFaq || faqUrl
  const commonProps = {
    variant: 'body2',
    color: 'inherit',
    ...NAVIGATION_BLANK_PARAMS
  }
  return (
    <Text
      label={
        <>
          {t('user-account.if-you-have-any-questions')}
          {faqEmail ? (
            <Trans
              i18nKey={customConfig.pleaseContactUsLabel}
              values={{ email: to }}
            >
              <Link href={`mailto:${to}`} {...commonProps} />
            </Trans>
          ) : (
            <Trans i18nKey='user-account.please-visit-our'>
              <Link href={brandConfig.helpCenterUrl} {...commonProps} />
              <Link href={to} {...commonProps} />
            </Trans>
          )}
        </>
      }
      variant='body2'
      color='text.secondary'
      component='span'
    />
  )
}

export default memo(CustomerHelpDesk)
